const configure = {

    // live link 
    // appUrl : "https://api.zithas.com/api/"

    // ztpl link 
    appUrl : " https://mars.ztpl.net/api/"
}
export default configure